<template>
  <div class="container styles">
    <div class="graphics">

      <canvas class="canvas" id="lineTwo"></canvas>
    </div>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
export default {
  props: ["tablaOne"],
  data() {
    return {
      itemList: [],
      anio: parseInt(process.env.VUE_APP_ANIO),
      graphicData: null,
      myChart: null,
      graphicOne: [],
    };
  },

  watch: {
    tablaOne: async function() {
      this.graphicOne.push(this.tablaOne);

      console.log("Prueba", this.graphicOne);
      await this.graficasTwo();
    },
  },

  methods: {
    graficasTwo: function() {
      var ctx = document.getElementById("lineTwo");
      if (this.myChart) {
        this.myChart.destroy();
      }
      this.myChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: [
            `${process.env.VUE_APP_ANIO - 2}`,
            `${process.env.VUE_APP_ANIO - 1}`,
            `${process.env.VUE_APP_ANIO}`,
          ],
          datasets: [
            {
              label: "Relación Presupuesto Final",
              data: [
                this.tablaOne.anioTwoPorcentaje,
                this.tablaOne.anioOnePorcentaje,
                this.tablaOne.anioActualPorcentaje,
              ],
              backgroundColor: ["#052333", "#052333"],
              borderColor: ["#052333", "#052333"],
              barThickness: 40,
            },
          ],

          options: {
            scales: {
              x: {
                title: {
                  display: true,
                  text: "Relación Laboral",
                  font: {
                    weight: "bold",
                  },
                },
                grid: {
                  display: false,
                },
              },
              y: {
                max: this.highestValue,
                display: true,
                title: {
                  display: true,
                  text: "Personas",
                  font: {
                    weight: "bold",
                  },
                },
                suggestedMin: -10,
                suggestedMax: 2000,
              },
            },
            plugins: {
              legend: {
                display: true,
                position: "bottom",
              },
              tooltip: {},
            },
          },
          responsive: true,
          plugins: {
            legend: {
              position: "right",
            },
          },
        },
      });
    },
  },

  mounted() {
    setTimeout(() => {
      this.graphics;
    }, 6000);
  },
};
</script>

<style scoped>
.graphics {
  width: 70% !important;
}

.styles {
  display: flex;
  justify-content: center;
}
</style>
